import preset from "../preset";

export type grid_cols = number;

export const gridColsClass = preset.xclasses<grid_cols>('gridCol');

export default gridColsClass;
